import React, { forwardRef, useRef } from "react";
import classnames from "classnames";
import { TextInputBase } from "../../text-input/text-input-base.jsx";
import { ExpirationDateProps } from "../types/expiration-date.types";
import { formatExpirationValue } from "../util/expiration-date.util";

export interface ExpirationDateForwardRef
  extends React.ForwardRefExoticComponent<
    ExpirationDateProps & React.RefAttributes<HTMLInputElement>
  > {}

export const ExpirationDateField = forwardRef<
  HTMLInputElement,
  ExpirationDateProps
>(
  (
    { placeHolder = "MM - YY", name, label = "Expiration", className, ...rest },
    ref
  ) => {
    const classes = classnames("spark-payment--expiration", className);
    const expRef = useRef<HTMLInputElement>(null);

    // This method is used to detect cursor position and change the position to after the hyphen
    const keyUpHandler = (e: React.KeyboardEvent): void => {
      const target = e.target as HTMLInputElement;

      if (!target) {
        return;
      }

      const { selectionStart, selectionEnd, value } = target;
      const skipCheck = e.key === "Backspace" || e.key === "Delete";

      if (selectionEnd === 2 && !skipCheck) {
        const refCurrent: HTMLInputElement = expRef.current!;
        if (refCurrent) {
          const selectionPos = selectionStart || 0;
          refCurrent.value = value + " - ";
          refCurrent.selectionStart = refCurrent.selectionEnd =
            selectionPos + 8;
        }
      }
    };

    return (
      <TextInputBase
        className={classes}
        placeHolder={placeHolder}
        name={name}
        label={label}
        typeaheadFormat={"\\d\\d - \\d\\d"}
        isTypeahead={true}
        isExpirationDate={true}
        formatInputValue={formatExpirationValue}
        ref={ref || expRef}
        onKeyUp={keyUpHandler}
        {...rest}
        type={"tel"}
      />
    );
  }
) as ExpirationDateForwardRef;

ExpirationDateField.displayName = "ExpirationDateField";
